// @flow
import React, { type Node } from 'react';
import styled, { type StyledComponent, css } from 'styled-components';

import {
  headingStyles,
  type HeadingSizes,
  responsiveHeadingStyles,
} from '@rover/design-system/style-dictionary/build/es6/theme';

import {
  margin,
  type MarginProps,
  textAlign,
  type TextAlignProps,
  textColor,
  type TextColorProps,
} from '@rover/react-lib/styles/styled-system';

import { MQ } from '@rover/react-lib/styles';

export type HeadingTags = 'div' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';

export type Props = {|
  ...MarginProps,
  ...TextAlignProps,
  ...TextColorProps,
  children: Node,
  as?: HeadingTags,
  responsive: boolean,
  size: HeadingSizes,
  id?: string,
|};

export const DEFAULT_TAGS_FOR_SIZES: { [HeadingSizes]: HeadingTags } = {
  '100': 'h5',
  '200': 'h4',
  '300': 'h3',
  '400': 'h2',
  '500': 'h1',
  '600': 'div',
};

export const getTag = (size: HeadingSizes, as?: HeadingTags) => {
  if (as) {
    return as;
  }
  return DEFAULT_TAGS_FOR_SIZES[size];
};

const StyledHeading: StyledComponent<Props, {}, mixed> = styled.p`
  padding: 0;
  margin: 0;
  border: 0 none;

  ${({ size }) => headingStyles[size]}
  ${({ responsive, size }) => {
    // $FlowFixMe Flow was unable to refine `props.size` based on `props.responsive`
    if (responsive && responsiveHeadingStyles[size]) {
      return css`
        ${MQ.NOT_XS} {
          ${responsiveHeadingStyles[size]}
        }
      `;
    }
    return '';
  }}
  ${margin}
  ${textAlign}
  ${textColor}
`;

const Heading = (props: Props) => <StyledHeading {...props} as={getTag(props.size, props.as)} />;

Heading.defaultProps = {
  size: '200',
  responsive: true,
};

export default Heading;



// WEBPACK FOOTER //
// ../react-lib/src/components/typography/Heading/Heading.jsx